import React from "react";
import { t } from "../i18n";

interface Props {
  isAccepting: boolean;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
}

const LiveStatusBadge: React.FC<Props> = ({
  isAccepting,
  onClick,
  className,
  style,
  ariaLabel,
}) => {
  const baseStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 12px",
    borderRadius: 20,
    background: isAccepting ? "rgba(36,201,97,0.12)" : "rgba(239,68,68,0.12)",
    border: "none",
    cursor: onClick ? "pointer" : "default",
    font: "inherit",
    color: isAccepting ? "#24C961" : "#ef4444",
    ...style,
  };

  const dot = (
    <span
      style={{
        width: 7,
        height: 7,
        borderRadius: "50%",
        background: isAccepting ? "#24C961" : "#ef4444",
        boxShadow: isAccepting
          ? "0 0 6px rgba(36,201,97,0.5)"
          : "0 0 6px rgba(239,68,68,0.5)",
        flexShrink: 0,
      }}
    />
  );
  const label = (
    <span
      style={{
        fontSize: "0.75rem",
        fontWeight: 600,
        letterSpacing: "0.03em",
      }}
    >
      {isAccepting ? t("liveStatusBadge.live") : t("liveStatusBadge.offline")}
    </span>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={className}
        style={baseStyle}
        aria-label={ariaLabel || (isAccepting ? t("liveStatusBadge.currentlyLiveTapTo") : t("liveStatusBadge.currentlyOfflineTapTo"))}
      >
        {dot}
        {label}
      </button>
    );
  }
  return (
    <div className={className} style={baseStyle} aria-label={ariaLabel}>
      {dot}
      {label}
    </div>
  );
};

export default LiveStatusBadge;
